import React, { useEffect, useState } from 'react';
import { evaluateDefinition, publishResults, clearResults } from './calculatorEvaluator';

export default function Calculator(props) {
  const definition = props.definition;
  const [inputs, setInputs] = useState(props.inputs || Object.fromEntries(definition.fields.map(field => [field.id, field.initial])));
  let state, message;
  try {
    const values = Object.fromEntries(definition.fields.map(field => {
      const raw = inputs[field.id];
      return [field.id, field.type === 'select' || raw == null || raw === '' ? raw : Number(raw)];
    }));
    state = evaluateDefinition(definition, values);
  } catch (error) {
    state = null;
    message = error.message || 'Revisa la definición antes de calcular.';
  }
  const serialized = JSON.stringify(state);
  useEffect(() => {
    publishResults(props.block_id, state ? state.results : []);
    if (state) setInputs(previous => {
      const next = { ...previous };
      let changed = false;
      state.field_states.forEach(field => {
        if (field.visibility !== 'visible' && next[field.field_id] != null) { next[field.field_id] = null; changed = true; }
      });
      return changed ? next : previous;
    });
  }, [serialized, props.block_id]);
  useEffect(() => () => clearResults(props.block_id), [props.block_id]);
  const invalid = Object.fromEntries((state ? state.field_states : []).map(field => [field.field_id, field.errors.length > 0]));
  function update(field, raw, badInput = false) {
    setInputs(previous => ({ ...previous, [field.id]: badInput ? NaN : raw }));
  }

  function item(entry) {
    if (entry.kind === 'result') {
      const config = definition.results.find(result => result.id === entry.id);
      const result = state && state.results.find(result => result.result_id === entry.id);
      const available = result && result.available;
      const value = available ? (result.format === 'percent' ? result.value * 100 : result.value).toLocaleString('es-EC', { maximumFractionDigits: result.precision, minimumFractionDigits: result.precision }) : 'No disponible';
      return <div key={entry.id} className="cms-result"><strong>{config.label}</strong><output>{value} {available && (result.format === 'percent' ? '%' : result.unit)}</output>{result && result.errors.map(error => <p key={error.code}>{error.message}</p>)}</div>;
    }
    const field = definition.fields.find(field => field.id === entry.id);
    const status = state && state.field_states.find(status => status.field_id === entry.id);
    if (status && status.visibility === 'hidden') return null;
    const id = `${props.block_id}-${field.id}`;
    return <div key={entry.id}><label htmlFor={id}>{field.label} {field.type === 'percent' ? '(%)' : field.unit}</label>
      {field.type === 'select' ? <select id={id} value={inputs[field.id] || ''} onChange={event => update(field, event.target.value)}><option value="">Selecciona una opción</option>{field.options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}</select> :
        <input id={id} type="number" step="any" min={field.min} max={field.max} value={inputs[field.id] == null || Number.isNaN(inputs[field.id]) ? '' : inputs[field.id]} aria-invalid={!!invalid[field.id]} aria-describedby={`${id}-help`} onChange={event => update(field, event.target.value, event.target.validity.badInput)} />}
      <p id={`${id}-help`}>{field.help}</p>{status && status.errors.map(error => <p role="alert" key={error.code}>{error.message}</p>)}
    </div>;
  }
  return <div className={`cms-calculator cms-presentation-${definition.presentation || 'cards'}`}>{definition.groups.map(group => <fieldset key={group.id}><legend>{group.label}</legend><p>{group.help}</p>{group.items.map(item)}</fieldset>)}<p role="status" aria-live="polite">{message}</p></div>;
}
